import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';
import type { AlternativeMethodCallbacks } from '../../types/verification';

type TryAnotherWayProps = AlternativeMethodCallbacks & {
  show: boolean;
};

export default function TryAnotherWay({
  show,
  onChooseSms,
  onChooseKba,
  onChooseProspect,
}: TryAnotherWayProps) {
  const { t } = useTranslation('common');
  const hasAnyOption = onChooseSms ?? onChooseKba ?? onChooseProspect;
  if (!show || !hasAnyOption) return null;

  return (
    <div className="space-y-3 pt-2">
      <p className="text-center text-sm text-gray-600 font-medium">
        {t('tryAnotherWay.prompt')}
      </p>
      {onChooseSms && (
        <Button
          id="alt-method-choose-sms"
          name="alt-method-choose-sms"
          type="button"
          onClick={onChooseSms}
          variant="outline"
          fullWidth
        >
          {t('tryAnotherWay.smsCode')}
        </Button>
      )}
      {onChooseKba && (
        <Button
          id="alt-method-choose-kba"
          name="alt-method-choose-kba"
          type="button"
          onClick={onChooseKba}
          variant="outline"
          fullWidth
        >
          {t('tryAnotherWay.securityQuestions')}
        </Button>
      )}
      {onChooseProspect && (
        <Button
          id="alt-method-choose-prospect"
          name="alt-method-choose-prospect"
          type="button"
          onClick={onChooseProspect}
          variant="outline"
          fullWidth
        >
          {t('tryAnotherWay.offerCode')}
        </Button>
      )}
    </div>
  );
}
